export default "__VITE_ASSET__Ca4OGMpj__"